export const SPREADSHEET_MODULE_NAME = 'SPREADSHEET';